import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import MoleculeNotification from '@s-ui/react-molecule-notification'

import {NOTIFICATIONS, NOTIFICATIONS_PROPS} from './config.js'

export const Notification = ({onClose = () => {}, type = NOTIFICATIONS.EMPTY}) => {
  const {i18n} = useContext(Context)

  const NOTIFICATIONS_LITERALS = {
    [NOTIFICATIONS.SUCCESS]: i18n.t('COMMON.FAVORITE_ADDED_NOTIFICATION_SUCCESS'),
    [NOTIFICATIONS.SUCCESS_DELETE]: i18n.t('COMMON.FAVORITE_DELETED_NOTIFICATION_SUCCESS'),
    [NOTIFICATIONS.ERROR]: i18n.t('COMMON.FAVORITE_ADDED_NOTIFICATION_ERROR'),
    [NOTIFICATIONS.ERROR_DELETE]: i18n.t('COMMON.FAVORITE_DELETED_NOTIFICATION_ERROR')
  }

  return (
    <MoleculeNotification onClose={onClose} {...NOTIFICATIONS_PROPS[type]}>
      {NOTIFICATIONS_LITERALS[type]}
    </MoleculeNotification>
  )
}

Notification.propTypes = {
  onClose: PropTypes.func,
  type: PropTypes.oneOf([NOTIFICATIONS.EMPTY, NOTIFICATIONS.ERROR, NOTIFICATIONS.SUCCESS, NOTIFICATIONS.SUCCESS_DELETE])
}
